import React from 'react';
import { FaDiscord } from 'react-icons/fa6';

const Footer = () => {
  return (
    <footer className="w-full bg-black/50 border-t border-white/10 mt-auto">
      <div className="container mx-auto px-6 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h3 className="text-xl font-bold gradient-text">KrukShop</h3>
            <p className="text-gray-400 text-sm">
              © 2025 KrukShop. {/* Wszelkie prawa zastrzeżone. */}
            </p>
          </div>
          <div className="flex items-center space-x-6">
            <a href="/regulamin" className="text-sm text-gray-300 hover:text-white transition-colors">Regulamin</a>
            <a href="/prywatnosc" className="text-sm text-gray-300 hover:text-white transition-colors">Prywatność</a>
            <a
              href="https://dc.krukshop.ovh"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="Discord"
            >
              <FaDiscord className="text-2xl" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;